<template>
  <div>
    <el-row :gutter="5" v-for="index in rowsNeed" :key="index">
      <el-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6" v-for="x in 4" :key="x">
        <AuditFileDetailCard v-if="list[row(index - 1, x - 1)]" :record="list[row(index - 1, x - 1)]" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AuditFileDetailCard from './AuditFileDetailCard.vue';
export default {
  components: { AuditFileDetailCard },
  props: ["list"],
  computed: {
    rowsNeed() {
      const lines = this.list ? this.list.length / 4 : 1;
      return Math.ceil(lines);
    },
  },
  methods: {
    row(index, count) {
      return (index * 4) + count;
    }
  },
  data() {
    return {
      started: 0,
    }
  }
}
</script>
